import React from 'react';
import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image';

const Image = (props: GatsbyImageProps) => {
  return <GatsbyImage {...props} objectFit="cover" />;
};

export default Image;
